<template>
  <div class="section">
    <header-page>
      <div class="d-flex align-items-center justify-content-between">
        <span class="text-dark fw-bold-700 size14">Point Balance</span>
        <b-button variant="primary" v-b-modal.setting-point>
          Atur Poin Persentase
        </b-button>
      </div>
    </header-page>

    <keep-alive>
      <component :is="comp" />
    </keep-alive>

    <b-modal
      id="setting-point"
      title="Atur Poin Persentase"
      ok-only
      ok-title="Simpan"
      :ok-disabled="!canAccessSettingPoint"
      @ok="updatePercentagePoint"
      @show="getPercentagePoint"
    >
      <b-row>
        <b-col cols="12" md="12" class="custom__form--input">
          <label class="mb-1">Persentase Poin Pelanggan</label>
          <div class="mb-0">
            <b-input-group append="%">
              <input
                :value="formPayload.loyalty_rules.percentage"
                id="decimal-input"
                type="number"
                step="0.01"
                min="0"
                max="100"
                @input="handleInput"
                @blur="handleBlur"
                placeholder="0.00" 
                class="custom__input text-capitalize w-100 px-1"
                :disabled="!canAccessSettingPoint"
              />
            </b-input-group>
            
          </div>
          <div v-if="errorMessage" class="error-message">
            {{ errorMessage }}
          </div>
        </b-col>
        <b-col cols="12">
          <div class="mt-1">
            <span class="text-danger fw-bold size14">Pergantian persentase point akan berpotensi menimbulkan selisih pada nominal pengembalian point saat terjadi retur penjualan.</span>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BButtonGroup,
  BDropdown,
  BDropdownItem,
  BImg,
  BPagination,
  BFormSelect,
  BModal,
  VBToggle,
  BRow,
  BCol,
  BFormInput, BInputGroup
} from "bootstrap-vue";

import HeaderPage from "@/components/HeaderPage.vue";
import TablePoint from "@/components/Point/TablePoint.vue";

import {
  checkPermission,
  successNotification,
  errorNotification,
} from "@/auth/utils";

export default {
  title() {
    return "Customer Point";
  },
  components: {
    BButton,
    HeaderPage,
    BButtonGroup,
    BDropdown,
    BDropdownItem,
    BImg,
    BPagination,
    BFormSelect,
    BModal,
    BRow,
    BCol,
    TablePoint,
    BFormInput, BInputGroup
  },
  directives: {
    "b-toggle": VBToggle,
  },
  setup() {
    return {
      checkPermission,
      successNotification,
      errorNotification,
    };
  },
  data() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    return {
      userData,
      comp: "TablePoint",
      formPayload: {
        loyalty_rules: {
          percentage: '0',
        },
      },
      isLoading: false,
      errorMessage: ''
    };
  },
  computed: {
    canAccessSettingPoint() {
      return checkPermission('setting point');
    }
  },
  created() { },
  methods: {
    handleInput(event) {
      const value = event.target.value
      // Reset error message
      this.errorMessage = ''
      
      // Allow empty input
      if (value === '') {
        this.formPayload.loyalty_rules.percentage = ''
        this.$emit('input', '')
        return
      }
      
      // Convert to number
      const numValue = parseFloat(value)
      
      // Check if it's a valid number
      if (isNaN(numValue)) {
        this.errorMessage = 'Please enter a valid number'
        return
      }
      
      // Check min/max range
      if (numValue < 0) {
        this.errorMessage = 'Value must be at least 0'
        return
      }
      
      if (numValue > 100) {
        this.errorMessage = 'Value must not exceed 100'
        return
      }
      
      // Check decimal places
      const decimalPlaces = this.countDecimalPlaces(value)
      if (decimalPlaces > 2) {
        this.errorMessage = 'Maximum 2 decimal places allowed'
        return
      }
      
      // If all validations pass, emit the value
      this.formPayload.loyalty_rules.percentage = numValue
      this.$emit('input', numValue)
    },
    
    handleBlur() {
      // Format the value on blur to ensure proper decimal places
      if (this.formPayload.loyalty_rules.percentage !== '' && !this.errorMessage) {
        const numValue = parseFloat(this.formPayload.loyalty_rules.percentage)
        if (!isNaN(numValue)) {
          // Format to maximum 2 decimal places
          const formatted = Math.round(numValue * 100) / 100
          this.formPayload.loyalty_rules.percentage = formatted
          this.$emit('input', formatted)
        }
      }
    },
    countDecimalPlaces(value) {
      if (value.toString().indexOf('.') !== -1) {
        return value.toString().split('.')[1].length
      }
      return 0
    },
    getPercentagePoint() {
      this.formPayload.loyalty_rules.percentage = this.userData.branch.loyalty_rules.percentage
    },
    updatePercentagePoint() {
      const form = new FormData();
      
      const branchUuid = this.userData?.branch?.uuid;
      
      this.isLoading = true;

      form.append("loyalty_rules[percentage]", this.formPayload?.loyalty_rules?.percentage);
      this.$swal({
        title: "Konfirmasi",
        text: 'Apakah Anda yakin, ingin mengganti persentase point yang didapatkan konsumen?',
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http
            .post(`merchantBranch-update-loyalty-rules/${branchUuid}`, form)
            .then(() => {
              successNotification(this, "Success", "Persentase poin berhasil dirubah!");
              this.isLoading = false;
              // window.location.reload();
            })
            .catch((error) => {
              this.isLoading = false;
              if (error.response.data.meta.messages.length > 0) {
                errorNotification(
                  this,
                  "Oops!",
                  error.response.data.meta.messages
                );
              }
            });
        }
      })
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.error-message {
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  color: #dc2626;
  font-size: 14px;
}
</style>
